import { useUrlLocalizer, useTranslator } from 'tradera/lang/translate';

type SellerNameProps = {
    memberId: number;
    cleanedAlias: string;
    alias: string;
    isCompany: boolean;
};
export const SellerName = ({
    memberId,
    cleanedAlias,
    alias,
    isCompany
}: SellerNameProps) => {
    const { toLocalizedUrl } = useUrlLocalizer();
    const { t } = useTranslator();

    const badgeText = isCompany && t('vip_sellerInfoCompany');

    return (
        <div className="pt-2">
            <div className="d-flex align-items-center flex-nowrap">
                {badgeText && (
                    <span className="badge badge-success mr-2">
                        {badgeText}
                    </span>
                )}
                <a
                    href={toLocalizedUrl(
                        `/profile/items/${memberId}/${cleanedAlias}`
                    )}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="size-berlin text-styled font-weight-bold">
                    {alias}
                </a>
            </div>
        </div>
    );
};
